/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Authagreementprivacypolicyurl4Inputs */



/**
* | output |
* | --- |
* | "https://www.chronock.ai/privacy" |
*
* @param {Authagreementprivacypolicyurl4Inputs} inputs
* @param {{ locale?: "ja-JP" | "en-US" | "fr-FR" | "de-DE" | "zh-TW" | "ko-KR" }} options
* @returns {LocalizedString}
*/
const authagreementprivacypolicyurl4 = /** @type {((inputs?: Authagreementprivacypolicyurl4Inputs, options?: { locale?: "ja-JP" | "en-US" | "fr-FR" | "de-DE" | "zh-TW" | "ko-KR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Authagreementprivacypolicyurl4Inputs, { locale?: "ja-JP" | "en-US" | "fr-FR" | "de-DE" | "zh-TW" | "ko-KR" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en-US") return /** @type {LocalizedString} */ ("https://www.chronock.ai/privacy")
	if (locale === "fr-FR") return /** @type {LocalizedString} */ ("https://www.chronock.ai/privacy")
	if (locale === "de-DE") return /** @type {LocalizedString} */ ("https://www.chronock.ai/privacy")
	if (locale === "zh-TW") return /** @type {LocalizedString} */ ("https://www.chronock.ai/privacy")
	if (locale === "ko-KR") return /** @type {LocalizedString} */ ("https://www.chronock.ai/privacy")
	return /** @type {LocalizedString} */ ("https://www.chronock.ai/ja-JP/privacy")
});
export { authagreementprivacypolicyurl4 as "authAgreementPrivacyPolicyUrl" }